import React from "react"
import Layout from '../components/layout/layout'
import StrechedHero from "../components/tips-para-estudiar/strechedHero"

export default () => (
  <Layout>
    <StrechedHero />
  </Layout>
)
